
document.body.addEventListener('click', function(e) {
  const trigger = e.target.closest('.wpml-ls-current-language');
  const languageLink = e.target.closest('.js-wpml-ls-sub-menu a');
  
  // ✅ Se si clicca su una lingua del sottomenù, lascia fare il comportamento nativo
  if (languageLink) {
    return;
  }

  // Se non è il trigger principale, ignora
  if (!trigger) return;

  // ❌ Blocca la navigazione solo per l’apertura/chiusura del menu
  e.preventDefault(); 

  const parentItem = trigger.closest('.wpml-ls-item');
  if (!parentItem) {
    console.warn('WPML Click: Genitore .wpml-ls-item non trovato');
    return;
  }

  const submenu = parentItem.querySelector('.js-wpml-ls-sub-menu');
  if (!submenu) {
    console.warn('WPML Click: Sottomenù .js-wpml-ls-sub-menu non trovato');
    return;
  }

  // Alterna visibilità
  const isHidden = (submenu.style.visibility === 'hidden') || (submenu.style.visibility === '');
  submenu.style.visibility = isHidden ? 'visible' : 'hidden';
});



// WEBPACK FOOTER //
// ./js/widget/select-lingue.js